<template>
  <CustomerList role-type="crp" title="CRP"/>
</template>

<script>
import CustomerList from "./customer-list";

export default {
  name: "CRP-Customer-List",
  components: {CustomerList}
}
</script>

<style scoped>

</style>